import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaCamera, FaMicrophone, FaVideoSlash } from "react-icons/fa";
import {
  FaBell,
  FaCommentAlt,
  FaHeart,
  FaShare,
  FaSearch,
  FaChevronDown,
  FaVolumeMute,
  FaVolumeUp,
  FaExclamationCircle,
} from "react-icons/fa";
import Leftsidebar from "../components/sidebar/leftsidebar";
import LeftResponsivesidebar from "../components/sidebar/left-responsive";
import Rightsidebar from "../components/sidebar/rightsidebar";
import Headmenu from "../components/sidebar/headmenu";
import videoslash from "../assets/images/icons/video-slash.png";
import videos from "../assets/images/icons/video.png";

import microphone from "../assets/images/icons/microphone.png"; // ✅ New Import
import cameraoff from "../assets/images/icons/camera-off.png";
// import golivecam from "../assets/images/icons/golive-cam.png";
import whiteheart from "../assets/images/icons/white-heart.svg";
import golivecam from "../assets/images/icons/golive-cam.png";
import global from "../assets/images/icons/global.svg";
import profileimg from "../assets/profile.png";
import like from "../assets/images/icons/like.png";
import golivebanner from "../assets/images/golive-prf.png";
import GoLiveDonationgiftModal from "./golivedonategiftModal";
import DonationHistory from "./DonationHistory";
import logo from "../assets/logo/Logo.svg";
import closeIcon from "../assets/images/icons/close-circle.png";
import axios from "axios";
import { io } from "socket.io-client";
import IVSBroadcastClient from "amazon-ivs-web-broadcast";
import editgolive from "../assets/images/icons/edit-golive.svg";
import GoLiveDonationModal from "./golivedonationmodal"; // ✅ Import the modal
import ReportStreamModal from "./ReportStreamModal"; // ✅ Import Report Modal
import Hls from "hls.js"; // ✅ Import for viewer mode HLS playback
import { toast } from "react-toastify"; // ✅ Import toast
import { initLiveStream } from "./services/liveService"; // ✅ Import liveService
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");

const SOCKET_URL = API_ORIGIN; // adjust if different

// ✅ Base URL for APIs
const BASE_URL = API_BASE_URL;

// ✅ Add viewerMode prop with default = false
export default function Golive({ viewerMode = false }) {
  const { streamId: urlStreamId } = useParams(); // ✅ Get streamId from URL for viewer mode
  // const streamIdToUse = viewerMode ? urlStreamId : null; // MOVED DOWN
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false); // ✅ State for Report Modal
  const [isDonateModalOpen, setIsDonateModalOpen] = useState(false); // ✅ State for Donate Modal
  const [isEditModalOpen, setIsEditModalOpen] = useState(false); // ✅ State for Edit Modal
  const [categoryName, setCategoryName] = useState("");
  const storedUser =
    sessionStorage.getItem("user") || localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const [startTime, setStartTime] = useState(null);
  const formatDate = (date) => {
    if (!date) return "";
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };
  const [profilePictureUrl, setProfilePictureUrl] = useState(() => {
    return sessionStorage.getItem("profilePictureUrl") || profileimg; // Default to placeholder image
  });

  // TEMP: replace this with your real logged-in user data
  const profiledata = {
    id: sessionStorage.getItem("userId"), // or from your auth provider
    username: sessionStorage.getItem("username") || "You",
  };
  const users = JSON.parse(
    sessionStorage.getItem("user") || localStorage.getItem("user"),
  );

  const [commentsEnabled, setCommentsEnabled] = useState(true);
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  // ✅ Handle Visibility Change with API Call
  const changeVisibility = async (newVisibility) => {
    // If we are setting up (no streamId), update immediately.
    if (!streamId) {
      setPrivacy(newVisibility);
      setIsOpen(false);
      return;
    }

    // If Live: Update ONLY on server success
    try {
      const res = await fetch(`${BASE_URL}/live/configure/${streamId}`, {
        method: "PATCH", // Use PATCH for updates
        headers: getAuthHeaders(),
        body: JSON.stringify({
          visibility: newVisibility.toLowerCase(),
        }),
      });
      const data = await res.json();

      if (res.ok && (data.success || data.status === "success")) {
        // Check API success flag too if standardized
        setPrivacy(newVisibility);
        setIsOpen(false);
        console.log("Visibility updated to:", newVisibility);
        toast.success(`Visibility changed to ${newVisibility}`);
      } else {
        console.error("Failed to update visibility:", data);
        toast.error("Failed to update visibility setting.");
        setIsOpen(false); // Close anyway or keep open? User preference usually close.
      }
    } catch (err) {
      console.error("Failed to update visibility:", err);
      toast.error("Network error updating visibility.");
      setIsOpen(false);
    }
  };

  // ✅ Handle Comments Toggle with API Call
  // This function handles the checkbox toggle for comments
  const toggleComments = async (e) => {
    // Determine new state based on checkbox (if event passed) or toggle current (if direct call)
    // The onChange event passes an event object.
    const newState = e && e.target ? e.target.checked : !commentsEnabled;

    // If setting up, just update
    if (!streamId) {
      setCommentsEnabled(newState);
      return;
    }

    try {
      const res = await fetch(`${BASE_URL}/live/configure/${streamId}`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          chat_enabled: newState,
        }),
      });
      const data = await res.json();

      if (res.ok && (data.success || data.status === "success")) {
        setCommentsEnabled(newState);
        toast.success(`Comments turned ${newState ? "ON" : "OFF"}`);
      } else {
        // Revert UI if failed (since the checkbox might have visually flipped)
        // Ideally we shouldn't flip state until success, but standard checkbox UX is optimistic.
        // For now, just error.
        toast.error("Failed to update comments setting.");
        // Optional: setCommentsEnabled(!newState); // revert
      }
    } catch (err) {
      console.error("Toggle comments error:", err);
      toast.error("Network error updating comments.");
    }
  };

  const [categories, setCategories] = useState([]); // ✅ Add categories state
  const toggleMic = async () => {
    console.log("toggleMic", "Current state:", isMicOn);

    if (!isMicOn) {
      // Turning mic ON - get fresh audio stream
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        const [audioTrack] = stream.getAudioTracks();

        audioTrackRef.current = audioTrack;

        // Add to camera stream if it exists
        if (cameraStream) {
          const oldAudioTrack = cameraStream.getAudioTracks()[0];
          if (oldAudioTrack) {
            oldAudioTrack.stop();
            cameraStream.removeTrack(oldAudioTrack);
          }
          cameraStream.addTrack(audioTrack);
        }

        // ✅ UPDATE IVS BROADCAST if live
        if (isLive && broadcastClientRef.current) {
          console.log("🔄 Updating IVS Audio Input (ON)");
          try {
            // Try to swap first
            await broadcastClientRef.current.exchangeAudioDeviceInput(
              "mic1",
              stream,
            );
          } catch (ivsErr) {
            console.warn(
              "IVS Audio Exchange Failed (will try adding):",
              ivsErr,
            );
            // Fallback: Just Add (since it was likely removed)
            try {
              await broadcastClientRef.current.addAudioInputDevice(
                stream,
                "mic1",
              );
            } catch (addErr) {
              console.error("IVS Audio Add Failed:", addErr);
            }
          }
        }

        setIsMicOn(true);
        console.log("✅ Mic turned ON");
      } catch (err) {
        console.error("❌ Failed to turn mic ON:", err);
        alert("Could not access microphone. Please check permissions.");
      }
    } else {
      // Turning mic OFF - stop and remove track completely
      if (audioTrackRef.current) {
        console.log("Stopping audio track...");

        // ✅ UPDATE IVS BROADCAST if live BEFORE stopping track references locally
        if (isLive && broadcastClientRef.current) {
          console.log("🔄 Updating IVS Audio Input (OFF)");
          try {
            broadcastClientRef.current.removeAudioInputDevice("mic1");
          } catch (ivsErr) {
            console.error("IVS Audio Remove Failed:", ivsErr);
          }
        }

        audioTrackRef.current.stop();

        if (cameraStream) {
          cameraStream.removeTrack(audioTrackRef.current);
        }

        audioTrackRef.current = null;
        setIsMicOn(false);
        console.log("✅ Mic turned OFF (stopped)");
      }
    }
  };

  const toggleCam = async () => {
    console.log("toggleCam", "Current state:", isCamOn);

    if (!isCamOn) {
      // Turning camera ON - get fresh video stream
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { width: 1280, height: 720, facingMode: "user" },
        });
        const [videoTrack] = stream.getVideoTracks();

        videoTrackRef.current = videoTrack;

        // Create new stream or add to existing one
        if (cameraStream) {
          // Remove old video track first
          const oldVideoTrack = cameraStream.getVideoTracks()[0];
          if (oldVideoTrack) {
            oldVideoTrack.stop();
            cameraStream.removeTrack(oldVideoTrack);
          }
          cameraStream.addTrack(videoTrack);
        } else {
          // Create new stream with just video track
          const newStream = new MediaStream([videoTrack]);
          // Add audio track if mic is on
          if (audioTrackRef.current) {
            newStream.addTrack(audioTrackRef.current);
          }
          setCameraStream(newStream);
        }

        // Update video element
        if (videoRef.current) {
          videoRef.current.srcObject = cameraStream;
          await videoRef.current
            .play()
            .catch((e) => console.log("Play error:", e));
        }

        // ✅ UPDATE IVS BROADCAST if live
        if (isLive && broadcastClientRef.current) {
          console.log("🔄 Updating IVS Video Input (ON)");
          try {
            // "camera1" is the name we used
            // Standard IVS web broadcast: exchangeVideoDevice(name, device, composition)
            // Note: composition { index: 0 } matches our initial setup
            await broadcastClientRef.current.exchangeVideoDeviceInput(
              "camera1",
              stream,
              { index: 0 },
            );
          } catch (ivsErr) {
            console.warn(
              "IVS Video Exchange Failed (will try adding):",
              ivsErr,
            );
            // Fallback: Just Add (since it was likely removed)
            try {
              await broadcastClientRef.current.addVideoInputDevice(
                stream,
                "camera1",
                { index: 0 },
              );
            } catch (addErr) {
              console.error("IVS Video Add Failed:", addErr);
            }
          }
        }

        setIsCamOn(true);
        console.log("✅ Camera turned ON");
      } catch (err) {
        console.error("❌ Failed to turn camera ON:", err);
        alert("Could not access camera. Please check permissions.");
      }
    } else {
      // Turning camera OFF - COMPLETE CLEANUP

      console.log("Turning camera OFF...");

      // ✅ UPDATE IVS BROADCAST if live BEFORE stopping track references locally
      if (isLive && broadcastClientRef.current) {
        console.log("🔄 Updating IVS Video Input (OFF)");
        try {
          broadcastClientRef.current.removeVideoInputDevice("camera1");
        } catch (ivsErr) {
          console.error("IVS Video Remove Failed:", ivsErr);
        }
      }

      // 1. Stop the video track from ref
      if (videoTrackRef.current) {
        console.log("Stopping video track from ref...");
        videoTrackRef.current.stop();
        videoTrackRef.current = null;
      }

      // 2. Stop ALL video tracks in the stream and remove them
      if (cameraStream) {
        const videoTracks = cameraStream.getVideoTracks();
        console.log(`Found ${videoTracks.length} video tracks in stream`);

        videoTracks.forEach((track) => {
          track.stop();
          cameraStream.removeTrack(track);
        });

        // ✅ KEY FIX: If no audio track exists, clear the entire stream
        const audioTracks = cameraStream.getAudioTracks();
        if (audioTracks.length === 0) {
          console.log("No audio tracks, clearing entire stream");
          setCameraStream(null);
        } else {
          // Keep stream alive but only with audio
          console.log("Keeping audio track alive");
        }
      }

      // 3. Clear the video element completely
      if (videoRef.current) {
        console.log("Clearing video element...");
        videoRef.current.pause();
        videoRef.current.srcObject = null;
        videoRef.current.load();
      }

      setIsCamOn(false);
      console.log("✅ Camera turned OFF - light should be off");
    }
  };

  // ✅ Updated stopCamera function
  const stopCamera = () => {
    try {
      console.log("stopCamera called");

      // Stop ALL tracks in the stream
      if (cameraStream) {
        const allTracks = cameraStream.getTracks();
        console.log(`Stopping ${allTracks.length} tracks...`);

        allTracks.forEach((track) => {
          console.log(`Stopping track: ${track.kind} - ${track.label}`);
          track.stop();
        });

        // ✅ Clear the stream state completely
        setCameraStream(null);
      }

      // Clear refs
      if (videoTrackRef.current) {
        videoTrackRef.current.stop();
        videoTrackRef.current = null;
      }

      if (audioTrackRef.current) {
        audioTrackRef.current.stop();
        audioTrackRef.current = null;
      }

      // Clear video element
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.srcObject = null;
        videoRef.current.load();
      }

      setChatMessages([]);
      setIsCamOn(false);
      setIsMicOn(false);

      console.log("✅ Camera completely stopped");
    } catch (err) {
      console.error("stopCamera error:", err);
    }
  };
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const token =
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken");
        const response = await axios.post(
          `${API_BASE_URL}/post/get-categorylist`,
          {
            filters: {},
            page: 1,
            limit: 10,
          },
          {
            headers: {
              token: token,
            },
          },
        );
        if (response.data.success && response.data.result?.categories) {
          setCategories(response.data.result.categories);
        }
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    };
    fetchCategories();
  }, []);

  // ✅ Define state properly
  const [isOpen, setIsOpen] = useState(false);

  const [isLive, setIsLive] = useState(false); // Tracks Go Live state

  // ✅ Live Duration Timer State (Moved here to fix ReferenceError)
  const [liveDuration, setLiveDuration] = useState(0);

  useEffect(() => {
    let interval;
    if (isLive) {
      interval = setInterval(() => {
        setLiveDuration((prev) => prev + 1);
      }, 1000);
    } else {
      setLiveDuration(0);
    }
    return () => clearInterval(interval);
  }, [isLive]);

  const formatDuration = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, "0")}:${m
      .toString()
      .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  // const [cameraStream, setCameraStream] = useState(null);
  // const [cameraError, setCameraError] = useState(false); // Tracks camera errors
  const [chatMessages, setChatMessages] = useState([]);
  const videoRef = useRef(null);
  const audioTrackRef = useRef(null);
  const videoTrackRef = useRef(null);
  const chatContainerRef = useRef(null); // ✅ Ref for chat scrolling

  const [isCamOn, setIsCamOn] = useState(false); // Default OFF
  const [isMicOn, setIsMicOn] = useState(false); // Default OFF

  // New state for stream session
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;

  // Redirect if no state is present (optional, but good for validation)
  useEffect(() => {
    if (!state) {
      // console.warn("No state found for Go Live Donation, redirecting...");
      // navigate("/donation");
    }
  }, [state, navigate]);

  const [streamId, setStreamId] = useState(null);
  // ✅ Define streamIdToUse HERE, after streamId is defined
  const streamIdToUse = viewerMode ? urlStreamId : streamId;

  const [donationIdForReport, setDonationIdForReport] = useState(null); // ✅ Store donation ID for reporting
  // Initialize state from location.state (passed from modal)
  const [title, setTitle] = useState(state?.title || "");
  const [category, setCategory] = useState(state?.category || "General");
  const [tags, setTags] = useState([]);
  const [privacy, setPrivacy] = useState("Public");

  // Derived values for display
  const [description, setDescription] = useState(state?.description || "");
  const [goalAmount, setGoalAmount] = useState(state?.goalAmount || "0");

  // Banking Info
  const [country, setCountry] = useState(state?.country || "N/A");
  const [beneficiaryName, setBeneficiaryName] = useState(
    state?.beneficiaryName || "N/A",
  );
  const [bankName, setBankName] = useState(state?.bankName || "N/A");
  const [accountNumber, setAccountNumber] = useState(
    state?.accountNumber || "N/A",
  );

  // ✅✅ VIEWER MODE STATE ✅✅
  const [playbackUrl, setPlaybackUrl] = useState(null); // HLS URL for viewer
  const [viewerStreamData, setViewerStreamData] = useState(null); // Stream metadata for viewer
  const [viewerCount, setViewerCount] = useState(0); // Real-time viewer count
  const [isMuted, setIsMuted] = useState(true); // ✅ Mute state for viewer
  const hlsRef = useRef(null); // HLS instance for viewer mode

  // ✅✅ ROLE DETECTION ✅✅
  // Determine if current user is the creator or a viewer
  const isCreator =
    !viewerMode && user && streamId && user.id === viewerStreamData?.creator_id;
  const isViewer =
    viewerMode ||
    (streamId && user && user.id !== viewerStreamData?.creator_id);
  const [ifsc, setIfsc] = useState(state?.ifsc || "N/A");
  const [currency, setCurrency] = useState(state?.currency || "$");

  // ✅✅ VIEWER MODE: Fetch Stream Data ✅✅
  // ✅✅ Fetch Stream Data (For both Viewer & Creator to ensure sync) ✅✅
  useEffect(() => {
    if (!streamIdToUse) return;

    const fetchStreamStatus = async () => {
      try {
        const token =
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken");

        const response = await fetch(
          `${BASE_URL}/live/status/${streamIdToUse}`,
          {
            headers: {
              "Content-Type": "application/json",
              token: token,
            },
          },
        );

        const data = await response.json();

        if (data.success && data.result) {
          const stream = data.result;
          console.log("✅ Stream Status Data:", stream);

          // Only set viewer-specific things if in viewer mode or needed
          if (viewerMode) {
            setViewerStreamData(stream);
            setPlaybackUrl(stream.playback_url);
          }

          // Update display state for both
          setTitle(stream.title || "Live Stream");
          setDescription(stream.description || "");
          setCategory(stream.category || "");
          setCategoryName(stream.category || ""); // ✅ Set categoryName directly as backend returns name now

          // Populate other fields from stream data
          if (stream.goal_amount) setGoalAmount(stream.goal_amount);

          // ✅ Populate Banking Info
          if (stream.bank_name) setBankName(stream.bank_name);
          if (stream.account_number) setAccountNumber(stream.account_number);
          if (stream.ifsc || stream.ifsc_code)
            setIfsc(stream.ifsc || stream.ifsc_code);
          if (stream.beneficiary_name)
            setBeneficiaryName(stream.beneficiary_name);
          // if (stream.country) setCountry(stream.country); // Removed per user request
          if (stream.currency) setCurrency(stream.currency);
          if (stream.visibility) setPrivacy(stream.visibility);

          // ✅ Sync comments enabled state
          if (typeof stream.chat_enabled !== "undefined") {
            setCommentsEnabled(stream.chat_enabled);
          }
        }
      } catch (err) {
        console.error("❌ Error fetching stream status:", err);
      }
    };

    fetchStreamStatus();
  }, [viewerMode, streamIdToUse]);

  // ✅ Initialize Category Name from ID if needed
  useEffect(() => {
    if (category && categories.length > 0) {
      const found = categories.find(
        (c) =>
          String(c.id) === String(category) ||
          String(c._id) === String(category) ||
          String(c.name) === String(category),
      );
      if (found) {
        setCategoryName(
          found.name || found.title || found.category_name || category,
        );
      } else {
        setCategoryName(category);
      }
    }
  }, [category, categories]);

  // ✅✅ VIEWER MODE: Initialize HLS Player ✅✅
  useEffect(() => {
    if (!viewerMode || !playbackUrl || !videoRef.current) return;

    console.log("🎥 Initializing HLS Player for viewer mode...");

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(playbackUrl);
      hls.attachMedia(videoRef.current);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        console.log("✅ HLS Manifest Parsed, playing video");
        videoRef.current.play().catch((e) => console.log("Autoplay failed", e));
      });

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("❌ HLS Error:", data);
      });

      hlsRef.current = hls;
    } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
      // Native HLS support (Safari)
      videoRef.current.src = playbackUrl;
      videoRef.current.addEventListener("loadedmetadata", () => {
        videoRef.current.play().catch((e) => console.log("Autoplay failed", e));
      });
    }

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }
    };
  }, [viewerMode, playbackUrl]);

  const [userProfile, setUserProfile] = useState(null); // ✅ Store user profile

  // ✅ Fetch User Profile
  useEffect(() => {
    // Only fetch if we are the creator and logged in
    if (viewerMode || !user || !user.id) return;

    const fetchProfile = async () => {
      try {
        const token =
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken");
        const res = await fetch(
          `${BASE_URL}/user/profile?id=${user.id}`, // Assuming this endpoint handles query param or just /user/profile with token
          {
            headers: {
              token: token,
              "Content-Type": "application/json",
            },
          },
        );
        const data = await res.json();
        if (data.success) {
          console.log("✅ Fetched User Profile:", data.result);
          setUserProfile(data.result);
        }
      } catch (err) {
        console.error("❌ Error fetching user profile:", err);
      }
    };
    fetchProfile();
  }, [viewerMode, user?.id]);

  const handleEditSave = async (updatedData) => {
    // 1. Update local state
    setTitle(updatedData.title);
    setCategory(updatedData.category);
    setDescription(updatedData.description);
    setGoalAmount(updatedData.goalAmount);

    setBankName(updatedData.bankName);
    setAccountNumber(updatedData.accountNumber);
    setIfsc(updatedData.ifsc);
    setBeneficiaryName(updatedData.beneficiaryName);
    setCurrency(updatedData.currency);
    // setCountry(updatedData.country); // if country is editable in modal

    // ✅ SAVE BANK DETAILS TO NEW API
    if (updatedData.bankName && updatedData.accountNumber) {
      try {
        const token =
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken");

        const payload = {
          organization_name:
            userProfile?.username || user?.username || "public",
          organization_address: userProfile?.location || "public",
          bank_name: updatedData.bankName,
          bank_account_number: updatedData.accountNumber,
          bank_ifsc_code: updatedData.ifsc,
          bank_account_holder_name: updatedData.beneficiaryName,
          bank_account_holder_address: userProfile?.location || "public", // Using location as holder address too
        };

        console.log("🏦 Saving Bank Details via API:", payload);

        const res = await fetch(`${BASE_URL}/user/add-organizer-details`, {
          method: "POST",
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const data = await res.json();
        if (data.success) {
          console.log("✅ Bank details saved successfully");
          toast.success("Bank details saved successfully!");
        } else {
          console.error("❌ Failed to save bank details:", data);
          // Optional: toast.error("Failed to save bank details");
        }
      } catch (err) {
        console.error("❌ Error calling add-organizer-details:", err);
      }
    }

    // 2. Persist to API immediately if we have a streamId
    if (streamId || streamIdToUse) {
      await saveMetadata(streamId || streamIdToUse, updatedData);
    }
  };

  const INGEST_URL =
    "rtmps://caa5358a392b.global-contribute.live-video.net:443/app/";
  const broadcastClientRef = useRef(null);

  // 1. Manage the visibility state

  // 2. Renamed function to open the modal
  const donategift = () => {
    setIsDonateModalOpen(true);
  };

  // ✅ Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // ✅ State for Session Resumption
  const [activeSessionAvailable, setActiveSessionAvailable] = useState(false);

  // ✅ Check for active stream on mount (Session Persistence)
  useEffect(() => {
    // Only check if we are a creator (not in viewerMode) and don't have a streamId yet
    if (viewerMode || streamId) return;

    const checkActiveStream = async () => {
      try {
        const token =
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken");
        const userId = users?.id;

        if (!token || !userId) return;

        const res = await fetch(`${BASE_URL}/live/list`, {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();

        if (data.success && Array.isArray(data.result)) {
          // Find stream belonging to current user
          // Assuming 'user' object in stream has 'id' or '_id'
          const myStream = data.result.find(
            (s) =>
              (s.user?.id === userId || s.user?._id === userId) &&
              s.status === "live",
          );

          if (myStream) {
            console.log("Found active session:", myStream);
            setStreamId(myStream.stream_id);
            setTitle(myStream.title);
            setDescription(myStream.description);
            setCategory(myStream.category);
            setPrivacy(myStream.privacy || "Public");
            // Auto-set isLive to true so UI reflects "Live" state
            setIsLive(true);
            // We might need to handle camera reconnection (it won't auto-start)
          }
        }
      } catch (err) {
        console.error("Error checking active stream:", err);
      }
    };

    checkActiveStream();
  }, [viewerMode, streamId, users]);

  // ✅ Fetch Donation History to get a valid donation_id for reporting
  useEffect(() => {
    if (!streamIdToUse) return;

    const fetchDonationId = async () => {
      try {
        const token =
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken");

        const response = await fetch(
          `${BASE_URL}/live/donation/history?stream_id=${streamIdToUse}&limit=1`,
          {
            headers: {
              "Content-Type": "application/json",
              token: token,
            },
          },
        );
        const data = await response.json();
        if (data.success && data.result?.donations?.length > 0) {
          // Use the first donation's ID
          setDonationIdForReport(data.result.donations[0].id);
          console.log(
            "✅ Found donation ID for report:",
            data.result.donations[0].id,
          );
        }
      } catch (err) {
        console.error("❌ Error fetching donation history:", err);
      }
    };

    fetchDonationId();
  }, [streamIdToUse]);

  const handleReportSubmit = async (reportData) => {
    // If we are in viewer mode, ensure we have a stream ID
    // User Requirement: Use donation_id from history API instead of stream_id
    // Fallback to streamId if no donation ID found (to avoid crash, though API might reject it)
    const targetId = donationIdForReport || streamIdToUse || streamId;

    if (!targetId) {
      toast.error("Stream ID missing. Cannot submit report.");
      return;
    }

    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      if (!token) {
        toast.error("You must be logged in to report.");
        return;
      }

      // API Endpoint: POST /live/donation/report
      // Payload: { donation_id, reason }
      const response = await fetch(`${BASE_URL}/live/donation/report`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({
          donation_id: targetId,
          reason: reportData.reason,
        }),
      });

      const data = await response.json();

      if (data.success) {
        toast.success("Report submitted successfully.");
        setIsReportModalOpen(false);
      } else {
        toast.error(data.message || "Failed to submit report.");
      }
    } catch (error) {
      console.error("Report submission error:", error);
      toast.error("An error occurred while reporting.");
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };

  // ✅ State for Donation History
  const [donations, setDonations] = useState([]);
  const [totalDonationAmount, setTotalDonationAmount] = useState(0);

  const fetchDonationHistory = async () => {
    if (!streamIdToUse) return;

    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      const headers = { "Content-Type": "application/json", token: token };

      if (!viewerMode) {
        // ✅ CREATOR MODE: Use Summary API for BOTH list and total
        // Endpoint: /live/{stream_id}/donation/summary
        const resSummary = await fetch(
          `${BASE_URL}/live/${streamIdToUse}/donation/summary`,
          { headers },
        );
        const dataSummary = await resSummary.json();

        if (resSummary.ok && dataSummary.success) {
          // 1. Set Total Amount
          setTotalDonationAmount(
            dataSummary.result?.summary?.total_amount || 0,
          );

          // 2. Set Donations List
          const mappedDonations = (dataSummary.result?.donations || []).map(
            (d) => ({
              id: d.id,
              type: "donation", // ✅ Distinguish from comments
              timestamp: d.created_at, // ✅ For sorting
              name:
                d.donor?.first_name && d.donor?.last_name
                  ? `${d.donor.first_name} ${d.donor.last_name}`
                  : d.donor?.username || "Anonymous",
              avatar:
                d.donor?.profile_picture_url ||
                "https://pipaan.s3.ap-south-1.amazonaws.com/default-profile.png",
              amount: d.amount,
              message: d.message || `Sent $${d.amount}`, // ✅ Display message
              time: new Date(d.created_at).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
            }),
          );
          setDonations(mappedDonations);
        }
      } else {
        // ✅ VIEWER MODE: Do NOT call /live/donation/history API as per user request.
        // We will rely on Socket 'new-donation' event to show real-time gifts in chat.
        setDonations([]);
      }
    } catch (err) {
      console.error("Error fetching donation history/summary:", err);
    }
  };

  // Poll for donation history
  // Poll for donation history
  useEffect(() => {
    // ✅ Fetch if we have a stream ID (live, preview, or ended), for both creator and viewer
    if (streamIdToUse) {
      fetchDonationHistory();
      const interval = setInterval(fetchDonationHistory, 10000);
      return () => clearInterval(interval);
    }
  }, [streamIdToUse]);

  // Dummy chat data for when live
  const liveChatMessages = [
    {
      id: 1,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 2,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 3,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 4,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 5,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 6,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 7,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 8,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 9,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
  ];

  // Put these near the top with your other hooks:

  // ✅ Start camera on mount for preview (ONLY for creators, not viewers)
  useEffect(() => {
    // if (!viewerMode) {
    //   startCamera();
    // }
    return () => stopCamera();
  }, [viewerMode]);

  // ✅ Prevent accidental refresh when live
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isLive && !viewerMode) {
        e.preventDefault();
        const msg = "If you refresh, your live stream will end.";
        e.returnValue = msg; // Most modern browsers ignore this and show default text
        return msg;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isLive, viewerMode]);

  const [cameraStream, setCameraStream] = useState(null);
  const [cameraError, setCameraError] = useState(false);

  // START CAMERA
  const startCamera = async () => {
    setCameraError(false);

    try {
      // navigator.permissions.query may not be supported in all browsers - wrap it
      try {
        const perm = await navigator.permissions.query?.({ name: "camera" });
        if (perm && perm.state === "denied") {
          alert(
            "Camera access is blocked. Click the lock icon next to the URL and allow Camera, then refresh.",
          );
          return;
        }
      } catch (permErr) {
        // ignore permission API errors and continue to request getUserMedia
        console.debug("Permissions API not available or failed:", permErr);
      }

      // Request camera + mic (you can set audio:false if you want preview without mic)
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { width: 1280, height: 720, facingMode: "user" },
        audio: true,
      });

      // ✅ Populate track refs for toggle buttons to work in pre-live mode
      const [videoTrack] = stream.getVideoTracks();
      const [audioTrack] = stream.getAudioTracks();
      videoTrackRef.current = videoTrack;
      audioTrackRef.current = audioTrack;

      // Save stream to state (we attach to the video element in useEffect below)
      setCameraStream(stream);
      setChatMessages(liveChatMessages);

      // debug
      console.log("✅ getUserMedia success, tracks:", stream.getTracks());
    } catch (err) {
      console.error("Error accessing camera/microphone:", err);
      setCameraError(true);
    }
  };

  // ATTACH STREAM TO VIDEO AFTER RERENDER
  useEffect(() => {
    let tryPlayTimeout = null;

    const attach = async () => {
      if (!cameraStream || !videoRef.current) return;

      try {
        videoRef.current.srcObject = cameraStream;
        videoRef.current.muted = true; // required for autoplay in many browsers (preview)
        // ensure playsInline and autoplay attributes are present on the element (see JSX below)
        const playPromise = videoRef.current.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch((err) => {
            // autoplay might be blocked; try again shortly
            console.warn("video.play() was rejected:", err);
            // small retry after a short delay
            tryPlayTimeout = setTimeout(() => {
              videoRef.current
                ?.play()
                .catch((e) => console.warn("retry play failed", e));
            }, 200);
          });
        }
      } catch (err) {
        console.error("Attach stream error:", err);
      }
    };

    attach();

    return () => {
      if (tryPlayTimeout) clearTimeout(tryPlayTimeout);
    };
  }, [cameraStream]);

  // STOP CAMERA
  // const stopCamera = () => {
  //   try {
  //     // stop media tracks stored in state
  //     if (cameraStream) {
  //       cameraStream.getTracks().forEach((t) => {
  //         try {
  //           t.stop();
  //         } catch (e) {
  //           /* ignore */
  //         }
  //       });
  //       setCameraStream(null);
  //     }

  //     // also pause and clear the video element
  //     if (videoRef.current) {
  //       try {
  //         videoRef.current.pause();
  //       } catch (e) {}
  //       try {
  //         videoRef.current.srcObject = null;
  //       } catch (e) {}
  //     }
  //     setChatMessages([]);
  //     // do NOT change isLive here if you manage it from handleGoLive
  //   } catch (err) {
  //     console.error("stopCamera error:", err);
  //   }
  // };

  // CLEANUP ON UNMOUNT (important)
  useEffect(() => {
    return () => {
      if (cameraStream) {
        cameraStream.getTracks().forEach((t) => {
          try {
            t.stop();
          } catch (e) {}
        });
      }
    };
  }, []); // run only on unmount

  const getAuthHeaders = () => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    if (!token) {
      throw new Error("Authentication token is missing. Please log in again.");
    }
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Keep for doc compliance
      token: token, // ✅ Add back custom header for backend compatibility
    };
  };

  // 1️⃣ Initialize Live Stream (Removed local definition, using service)
  // const initLiveStream = ... (removed)

  // 2️⃣ Save Metadata
  // 2️⃣ Save Metadata
  const saveMetadata = async (id, dataOverride = null) => {
    const sid = id || streamId; // ✅ Prefer passed id, fallback to state
    if (!sid) return;

    // Find category name from ID
    const currentCategoryId = dataOverride?.category || category;
    const foundCategory = categories?.find(
      (c) =>
        String(c.id) === String(currentCategoryId) ||
        String(c._id) === String(currentCategoryId) ||
        String(c.name) === String(currentCategoryId),
    );
    setCategoryName(
      foundCategory
        ? foundCategory.name ||
            foundCategory.title ||
            foundCategory.category_name
        : currentCategoryId,
    );

    // Use override data if available (for immediate updates), else state
    const payload = {
      stream_id: sid,
      title: dataOverride?.title || title,
      category: categoryName || "", // ✅ Ensure it is not undefined
      tags: ["live", categoryName || ""],
      description: dataOverride?.description || description,
      goal_amount: Number(dataOverride?.goalAmount || goalAmount) || 0,
    };

    try {
      const res = await fetch(`${BASE_URL}/live/metadata`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        console.log("Metadata saved:", data.result);
        await setPreview(sid); // ✅ Chain next step with sid
      } else {
        console.error("Metadata failed:", data.message);
      }
    } catch (err) {
      console.error("Metadata Error:", err);
    }
  };

  // 3️⃣ Set Preview
  const setPreview = async (id) => {
    const sid = id || streamId;
    if (!sid) return;
    try {
      await fetch(`${BASE_URL}/live/preview`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ stream_id: sid }),
      });
      console.log("Stream is in preview mode");
    } catch (err) {
      console.error("Preview Error:", err);
    }
  };
  const [countdown, setCountdown] = useState(0);

  // 4️⃣ Start Live
  const startLive = async (id) => {
    const sid = id || streamId;
    if (!sid) return;
    try {
      await fetch(`${BASE_URL}/live/start`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ stream_id: sid }),
      });
      console.log("Stream started");
    } catch (err) {
      console.error("Start Live Error:", err);
    }
  };

  // 5️⃣ End Live
  const endLive = async (id) => {
    if (broadcastClientRef.current) {
      await broadcastClientRef.current.stopBroadcast();
      broadcastClientRef.current = null;
      console.log("🛑 Broadcast stopped");
    }

    const sid = id || streamId;
    if (!sid) return;
    try {
      await fetch(`${BASE_URL}/live/end`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ stream_id: sid }),
      });
      console.log("Stream ended");
      navigate("/donation"); // ✅ Redirect to donation page
    } catch (err) {
      console.error("End Live Error:", err);
    }
  };

  // 🔥 Final Go Live Handler
  // const handleGoLive = async () => {
  //    // ✅ Validate required fields
  // if (!title.trim() || !category.trim()) {
  //   alert("Please enter a title and category before going live.");
  //   return;
  // }
  //   if (isLive) {
  //         await endLive();   // ✅ End first

  //     stopCamera();
  //     // await endLive();
  //     setIsLive(false);
  //         setCountdown(0);

  //   } else {
  //     await initLiveStream();
  //     // await saveMetadata();
  //     // await setPreview();
  //     await startCamera();
  //     await startLive();
  //     setIsLive(true);
  //   }
  // };

  // ✅ Handle Resume Live Stream
  const handleResumeLive = async () => {
    if (!streamId) return;

    try {
      const res = await fetch(`${BASE_URL}/live/status/${streamId}`, {
        headers: getAuthHeaders(),
      });
      const data = await res.json();

      const streamKey =
        data.result?.stream_key || data.result?.stream?.stream_key;

      if (!streamKey) {
        alert(
          "Unable to retrieve stream key. You may need to start a new stream.",
        );
        return;
      }

      const ingestEndpoint =
        "rtmps://caa5358a392b.global-contribute.live-video.net:443/app/";
      const ingestUrl = `${ingestEndpoint}${streamKey}`;

      const config = {
        maxResolution: { width: 1280, height: 720 },
        maxFramerate: 30,
        maxBitrate: 3500,
      };
      const client = IVSBroadcastClient.create({ streamConfig: config });

      let localStream = null;
      if (isCamOn || isMicOn) {
        try {
          localStream = await navigator.mediaDevices.getUserMedia({
            video: isCamOn ? { width: 1280, height: 720 } : false,
            audio: isMicOn,
          });
        } catch (mediaErr) {
          console.error("Error getting media:", mediaErr);
          alert("Could not access media devices.");
        }
      }

      if (localStream) {
        setCameraStream(localStream);
        if (isCamOn) {
          const [videoTrack] = localStream.getVideoTracks();
          if (videoTrack) {
            videoTrackRef.current = videoTrack;
            client.addVideoInputDevice(localStream, "camera1", { index: 0 });
          }
        }
        if (isMicOn) {
          const [audioTrack] = localStream.getAudioTracks();
          if (audioTrack) {
            audioTrackRef.current = audioTrack;
            client.addAudioInputDevice(localStream, "mic1");
          }
        }
        if (isCamOn && videoRef.current) {
          videoRef.current.srcObject = localStream;
        }
      }

      broadcastClientRef.current = client;

      await client.startBroadcast(ingestUrl);
      console.log("✅ Broadcast Resumed");

      setIsLive(true);
      setActiveSessionAvailable(false);
      setCountdown(0);
    } catch (err) {
      console.error("Error resuming stream:", err);
      alert("Failed to resume stream.");
    }
  };

  const handleGoLive = async () => {
    if (isLive) {
      // 🔴 Stop flow
      await endLive();
      stopCamera();
      setIsLive(false);
      setCountdown(0);
    } else {
      // 🟢 Start flow
      if (!title.trim()) {
        alert("Please fill in Title before going live.");
        return;
      }

      try {
        // 1️⃣ Init Stream (Get Stream ID & Key)
        const result = await initLiveStream({
          recording_enabled: false,
          stream_type: "donation",
          distroy_previous_stream: true,
          navigation_source: "donate",
        });

        const sid = result.stream_id;
        const streamKey = result.stream_key; // Provided by init

        // 1.5 Configure Stream (Privacy & Features)
        // Now using stream_id from init
        await fetch(`${BASE_URL}/live/configure`, {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify({
            stream_id: sid,
            visibility: privacy.toLowerCase(),
            chat_enabled: commentsEnabled,
            donation_enabled: true,
            reactions_enabled: true,
          }),
        });
        if (!sid)
          throw new Error("Stream ID not returned from initialization.");

        // If streamKey is missing, we can't ingest (unless IVS config handles it differently?)
        // The previous code had: const ingestUrl = `rtmps://.../${streamKey}`;
        // Let's keep it safe.

        const ingestUrl = streamKey
          ? `rtmps://caa5358a392b.global-contribute.live-video.net:443/app/${streamKey}`
          : "";

        // 2️⃣ Save Metadata (and trigger Preview via helper)
        // This helper uses the fixed payload (no description)
        await saveMetadata(sid);

        setStreamId(sid); // ✅ Move setStreamId AFTER saveMetadata to avoid fetching empty data race condition

        // 3️⃣ Preview is handled inside saveMetadata, but for safety/clarity, ensure it's done.
        // saveMetadata calls setPreview(sid) on success.
        // So we don't need to manually fetch /live/preview here.

        // 🎬 Show countdown
        setCountdown(3);
        let timer = 3;
        const interval = setInterval(async () => {
          timer -= 1;
          setCountdown(timer);

          if (timer === 0) {
            clearInterval(interval);

            // ✅ Initialize the Amazon IVS Web Broadcast SDK here
            try {
              // Manual config since BasicStreamConfig import is failing
              const config = {
                maxResolution: { width: 1280, height: 720 },
                maxFramerate: 30,
                maxBitrate: 3500,
              };

              const client = IVSBroadcastClient.create({
                streamConfig: config,
              });

              // ✅ CONDITIONALLY Capture local camera & microphone based on pre-live state
              let localStream = null;

              if (isCamOn || isMicOn) {
                try {
                  localStream = await navigator.mediaDevices.getUserMedia({
                    video: isCamOn ? { width: 1280, height: 720 } : false,
                    audio: isMicOn,
                  });
                } catch (mediaErr) {
                  console.error("Error getting media for broadcast:", mediaErr);
                  alert(
                    "Could not access media devices. Starting without them.",
                  );
                }
              }

              // Update state references
              if (localStream) {
                setCameraStream(localStream); // Keep state in sync

                if (isCamOn) {
                  const [videoTrack] = localStream.getVideoTracks();
                  if (videoTrack) {
                    videoTrackRef.current = videoTrack;
                    // IVS SDK: Add video
                    client.addVideoInputDevice(localStream, "camera1", {
                      index: 0,
                    });
                  }
                }

                if (isMicOn) {
                  const [audioTrack] = localStream.getAudioTracks();
                  if (audioTrack) {
                    audioTrackRef.current = audioTrack;
                    // IVS SDK: Add audio
                    client.addAudioInputDevice(localStream, "mic1");
                  }
                }

                // Show local camera preview if video is present
                if (isCamOn && videoRef.current) {
                  videoRef.current.srcObject = localStream;
                }
              } else {
                // Both off, clean state just in case
                setCameraStream(null);
                if (videoRef.current) videoRef.current.srcObject = null;
              }

              // IVS Web Broadcast SDK expects startBroadcast(streamKey, ingestEndpoint)
              const ingestEndpoint =
                "rtmps://caa5358a392b.global-contribute.live-video.net:443/app/"; // Protocol and path might be needed depending on SDK version, but usually SDK handles it if we pass key separate.
              // Actually, checking standard docs: client.startBroadcast(streamKey, ingestEndpoint)
              // ingestEndpoint should be "caa5358a392b.global-contribute.live-video.net"
              const endpoint = "caa5358a392b.global-contribute.live-video.net";
              // Debug logs
              console.log("Start Broadcast Debug:", { streamKey, endpoint });

              if (!streamKey) throw new Error("Stream Key is missing!");

              await client.startBroadcast(streamKey, endpoint);
              console.log("🎥 Stream is live on IVS:", endpoint);

              // ✅ Save broadcast client ref so you can stop it later
              broadcastClientRef.current = client;
            } catch (err) {
              console.error("❌ IVS Broadcast Error:", err);
              alert(`Failed to start live broadcast: ${err.message}`);
              return;
            }

            // 5️⃣ Call backend /live/start API after the IVS broadcast starts
            await startLive(sid);
            setIsLive(true);
            setCountdown(0);
          }
        }, 1000);
      } catch (err) {
        console.error("Go Live Error:", err);
        alert(err.message);
      }
    }
  };

  const [comments, setComments] = useState([]);

  // ✅ Auto-scroll to bottom when comments change
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [comments]); // store all comments
  const [comment, setComment] = useState(""); // input field value
  const [socket, setSocket] = useState(null);
  const [streamStatus, setStreamStatus] = useState("idle");

  const deleteComment = async (commentId) => {
    if (!streamIdToUse || !commentId) return;

    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");
      if (!token) {
        alert("Authentication required");
        return;
      }

      const res = await fetch(
        `${BASE_URL}/streams/${streamIdToUse}/comments/${commentId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            stream_id: streamIdToUse,
            comment_id: commentId,
          }),
        },
      );

      const data = await res.json();

      if (res.ok && data.success) {
        console.log("✅ Comment deleted:", data.result);
        // Remove from UI
        setComments((prev) => prev.filter((c) => c.commentId !== commentId));
      } else {
        console.error("❌ Delete comment failed:", data.message);
      }
    } catch (err) {
      console.error("Delete Comment Error:", err);
    }
  };

  // ✅ Engagement Stats
  const [engagementStats, setEngagementStats] = useState({
    totalReactions: 0,
    totalGifts: 0,
    totalCoins: 0,
  });

  const fetchEngagementStats = async () => {
    if (!streamIdToUse) return;
    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      const res = await fetch(`${BASE_URL}/live/${streamIdToUse}/engagement`, {
        headers: { "Content-Type": "application/json", token },
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setEngagementStats(data.result.engagement);
      }
    } catch (err) {
      console.error("Error fetching engagement stats:", err);
    }
  };

  // Poll engagement stats for creator
  useEffect(() => {
    if (streamIdToUse && !viewerMode) {
      fetchEngagementStats();
      const interval = setInterval(fetchEngagementStats, 10000); // 10s
      return () => clearInterval(interval);
    }
  }, [streamIdToUse, viewerMode]);

  const fetchComments = async () => {
    if (!streamIdToUse) return;

    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");
      if (!token) {
        alert("Authentication required");
        return;
      }

      const res = await fetch(
        `${BASE_URL}/streams/${streamIdToUse}/comments?limit=50`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            token,
          },
        },
      );

      const data = await res.json();

      if (res.ok && data.success) {
        console.log("✅ Comments fetched:", data.result.comments);

        // store the array of comments
        setComments(
          Array.isArray(data.result.comments) ? data.result.comments : [],
        );
      } else {
        console.error("❌ Fetch comments failed:", data.message);
      }
    } catch (err) {
      console.error("Fetch Comments Error:", err);
    }
  };

  // ✅ Function to post comment
  const postComment = async () => {
    if (!comment.trim() || !streamIdToUse) return;

    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");
      if (!token) {
        alert("Authentication required");
        return;
      }

      const res = await fetch(`${BASE_URL}/streams/${streamIdToUse}/comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify({
          comment: comment,
          timestamp: new Date().toISOString(),
        }),
      });

      const data = await res.json();

      if (res.ok && data.success) {
        console.log("✅ Comment added:", data.result);
        setComment("");
        // ✅ Rely on socket to update comments for self and others
        // setComments((prev) => [...]);
        // fetchComments();
      } else {
        console.error("❌ Comment failed:", data.message);
        toast.error(data.message || "Failed to post comment");
      }
    } catch (err) {
      console.error("Comment API Error:", err);
    }
  };
  useEffect(() => {
    if (streamIdToUse) {
      fetchComments();
    }
  }, [streamIdToUse]);

  // ✅ Engagement State
  const [reactions, setReactions] = useState([]);

  // ✅ Handle Like
  const [isLikeAnimating, setIsLikeAnimating] = useState(false);

  const handleLike = async () => {
    // Trigger animation immediately
    setIsLikeAnimating(true);
    setTimeout(() => setIsLikeAnimating(false), 300);

    const targetStreamId = streamIdToUse || streamId;
    if (!targetStreamId) return;

    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      console.log("👍 Sending like for stream:", targetStreamId);

      // Use API as per documentation
      const res = await fetch(`${BASE_URL}/live/${targetStreamId}/reaction`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({
          type: "like",
        }),
      });

      const data = await res.json();
      if (res.ok && data.success) {
        console.log("✅ Like sent successfully");
      } else {
        console.error("❌ Failed to send like:", data);
      }
    } catch (err) {
      console.error("Error sending like:", err);
    }
  };

  useEffect(() => {
    if (!streamIdToUse) return;

    // ✅ Connect socket
    const s = io(SOCKET_URL, {
      transports: ["websocket"],
      auth: {
        token:
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken"), // send token if required
      },
    });

    setSocket(s);

    // ✅ Join stream comments room
    if (profiledata?.id) {
      s.emit("join-stream-comments", {
        streamId: streamIdToUse,
        userId: profiledata.id,
      });
    } else {
      console.warn("Joining comments room as guest (no userId)");
      // Optional: Emit as guest if backend supports it
      s.emit("join-stream-comments", {
        streamId: streamIdToUse,
        userId: "guest",
      });
    }

    // ✅ Handle recent comments (on joining)
    s.on("recent-comments", (data) => {
      console.log("Recent comments:", data);
      setComments(data.comments || []);
    });

    // ✅ Handle new comment
    s.on("new-comment", (data) => {
      console.log("New comment:", data);
      setComments((prev) => {
        // Prevent random duplicates
        if (prev.some((c) => c.commentId === data.commentId)) return prev;
        return [...prev, data];
      });
    });

    // ✅ Handle new donation (Real-time)
    s.on("new-donation", (data) => {
      console.log("🎁 New donation received:", data);
      const newDonation = {
        id: data.id || Date.now(),
        type: "donation",
        timestamp: data.created_at || new Date().toISOString(),
        name: data.donor_name || data.username || "Anonymous",
        avatar:
          data.donor_avatar ||
          "https://pipaan.s3.ap-south-1.amazonaws.com/default-profile.png",
        amount: data.amount || data.coinValue || 0,
        message:
          data.message ||
          (data.giftName ? `Sent ${data.giftName}` : `Sent donation`),
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      };
      setDonations((prev) => [newDonation, ...prev]);
    });

    // ✅ Handle deleted comment
    s.on("comment-deleted", (data) => {
      console.log("Comment deleted:", data);
      setComments((prev) => prev.filter((c) => c.commentId !== data.commentId));
    });

    // ✅ Cleanup when leaving
    return () => {
      s.emit("leave-stream-comments", {
        streamId: streamIdToUse,
        userId: profiledata?.id,
      });
      s.disconnect();
    };
  }, [streamIdToUse, profiledata?.id]);

  useEffect(() => {
    if (!streamIdToUse) return;

    const s = io(SOCKET_URL, {
      transports: ["websocket"],
      auth: {
        token:
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken"),
      },
    });

    setSocket(s);

    // ✅ Join stream room
    if (users?.id) {
      s.emit("join-stream", {
        streamId: streamIdToUse,
        userId: users.id,
      });
      // ✅ Join engagement room for Likes/Gifts
      s.emit("join-stream-engagement", {
        streamId: streamIdToUse,
        userId: users.id,
      });
    } else {
      console.log("Joined stream as guest (no userId)");
      s.emit("join-stream", {
        streamId: streamIdToUse,
        userId: "guest",
      });
      s.emit("join-stream-engagement", {
        streamId: streamIdToUse,
        userId: "guest",
      });
    }

    // ✅ Listeners
    s.on("viewer-count-updated", (data) => {
      console.log("Viewer count updated:", data);
      setViewerCount(data.viewerCount);
    });

    // ✅ Handle New Reaction (Like)
    s.on("new-reaction", (data) => {
      console.log("❤️ New reaction:", data);
      const newReaction = {
        id: Date.now() + Math.random(),
        type: "like",
        timestamp: new Date().toISOString(),
        username: data.user?.username || data.username || "Anonymous",
        avatar: data.user?.profilePictureUrl || profileimg,
        message: "liked the stream",
      };
      // Use setReactions (need to define this state)
      setReactions((prev) => [...prev, newReaction]);
    });

    // ✅ Handle Current Engagement (Initial Load)
    s.on("current-engagement", (data) => {
      console.log("Current engagement:", data);
      // Update stats if we were using them
      if (data.engagement) {
        setEngagementStats(data.engagement);
      }
    });

    s.on("new-viewer", (data) => {
      console.log("New viewer joined:", data);
    });

    s.on("viewer-left", (data) => {
      console.log("Viewer left:", data);
    });

    s.on("stream-initiated", (data) => {
      console.log("Stream initiated:", data);
      setStreamStatus("initiated");
    });

    s.on("stream-preview", (data) => {
      console.log("Stream in preview mode:", data);
      setStreamStatus("preview");
    });

    s.on("stream-started", (data) => {
      console.log("Stream started:", data);
      setStreamStatus("started");
    });

    s.on("stream-went-live", (data) => {
      console.log("Stream went live:", data);
      setStreamStatus("live");
    });

    s.on("stream-ended", (data) => {
      console.log("Stream ended:", data);
      setStreamStatus("ended");
      if (viewerMode) {
        toast.info("Live stream has ended. Redirecting...", {
          autoClose: 3000,
        });
        setTimeout(() => {
          navigate("/");
        }, 3000);
      }
    });

    s.on("stream-room-closed", (data) => {
      console.log("Stream room closed:", data);
      setStreamStatus("closed");
    });

    // ✅ Cleanup
    return () => {
      if (s) {
        s.emit("leave-stream", {
          streamId: streamIdToUse,
          userId: users.id,
        });
        s.disconnect();
      }
    };
  }, [streamIdToUse, users?.id]);

  return (
    <div className="dashboard w-full min-h-screen  flex">
      {/* Sidebar */}
      <Leftsidebar />
      <main className="flex-1 p-6 go-live">
        <div className="px-6 pt-6 navbar-golive">
          <LeftResponsivesidebar />
          <Headmenu />
        </div>
        {/* <LeftResponsivesidebar />
                <Headmenu /> */}
        {/* Main Content */}
        <main className="row flex items-stretch golivresponsive">
          <div className="flex-1 lg:pr-4 xl:pr-5">
            {/* GoLive Content */}
            <div className="pt-0">
              {/* Add Title Input */}
              {(isLive || viewerMode) && (
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <h1 className="text-2xl font-bold text-gray-900">
                      {title || "Untitled Stream"}
                    </h1>
                    <div className="flex items-center text-sm text-gray-500 mt-1 space-x-2">
                      <span>{formatDate(new Date())}</span>
                      <span>|</span>
                      <span className="flex items-center gap-1 text-green-700 font-medium">
                        <img src={global} alt="Public" className="w-3 h-3" />{" "}
                        {privacy}
                      </span>
                    </div>
                  </div>
                  {!viewerMode && (
                    <div className="text-xl font-medium tracking-wide">
                      {formatDuration(liveDuration)}
                    </div>
                  )}
                </div>
              )}
              <div className="bg-[#EBF8ED] golive-body">
                {/* Camera Screen Placeholder */}
                <div className="bg-black text-white flex flex-col items-center justify-center camera relative h-[500px] rounded-3xl overflow-hidden">
                  {/* ✅ VIEWER MODE: HLS Player with Streamer Info Overlay */}
                  {viewerMode ? (
                    <div className="w-full h-full relative">
                      {/* Check if stream ended */}
                      {(streamStatus === "ended" ||
                        streamStatus === "closed") && (
                        <div className="absolute inset-0 z-50 bg-black flex flex-col items-center justify-center text-white">
                          <h2 className="text-3xl font-bold mb-4">
                            Stream Ended
                          </h2>
                          <p className="text-gray-400">
                            Redirecting to home...
                          </p>
                        </div>
                      )}

                      {/* HLS Video Player */}
                      <video
                        ref={videoRef}
                        autoPlay
                        playsInline
                        controls
                        className="w-full h-full object-cover"
                      />

                      {/* Streamer Profile Overlay - Top Left */}
                      <div className="absolute top-4 left-4 bg-white bg-opacity-90 rounded-lg px-3 py-2 flex items-center gap-2">
                        <img
                          src={
                            viewerStreamData?.user?.profile_picture_url ||
                            profilePictureUrl
                          }
                          alt="Streamer"
                          className="w-8 h-8 rounded-full object-cover"
                        />
                        <div>
                          <p className="text-sm font-semibold text-gray-900">
                            {viewerStreamData?.user?.first_name ||
                              user?.first_name ||
                              "Streamer"}
                          </p>
                          <p className="text-xs text-gray-600">
                            {formatDate(
                              viewerStreamData?.created_at
                                ? new Date(viewerStreamData.created_at)
                                : new Date(),
                            )}
                          </p>
                        </div>
                      </div>

                      {/* Fullscreen Icon - Top Right */}
                      <button className="absolute top-4 right-4 bg-white bg-opacity-80 rounded-md p-2 hover:bg-opacity-100 transition">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-gray-700"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 8V4m0 0h4M4 4l5 5m11-5v4m0-4h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5"
                          />
                        </svg>
                      </button>

                      {/* Viewer Count Badge - Bottom Left */}
                      <div className="absolute bottom-4 left-4 bg-black bg-opacity-70 text-white px-3 py-1 rounded-md text-sm font-semibold">
                        {viewerCount > 1000
                          ? (viewerCount / 1000).toFixed(1) + "K"
                          : viewerCount}{" "}
                        Viewers
                      </div>

                      {/* LIVE Badge - Bottom Right */}
                      <div className="absolute bottom-4 right-4 bg-red-600 text-white px-4 py-1 rounded-md text-sm font-bold">
                        LIVE
                      </div>
                    </div>
                  ) : /* ✅ CREATOR MODE: Camera Stream with Controls */
                  cameraStream ? (
                    <div className="w-full h-full">
                      <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                        <div className="flex p-2 pl-5 items-center">
                          {/* Profile Image Inside Textarea */}
                          <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                            <img
                              src={profilePictureUrl}
                              alt="Profile"
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <div className="feed-title pl-4">
                            <p className="font-semibold text-[#000]">
                              {user?.first_name} {user?.last_name}
                            </p>
                            <p className="flex text-sm text-[#000]">
                              {startTime && formatDate(startTime)}
                            </p>
                          </div>
                        </div>
                      </div>
                      {countdown > 0 && (
                        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-70 text-white text-4xl font-bold z-50">
                          Going live in {countdown}...
                        </div>
                      )}

                      <video
                        ref={videoRef}
                        autoPlay
                        playsInline
                        muted
                        style={{
                          width: "100%",
                          height: "100%",
                          backgroundColor: "black",
                        }}
                        className="w-full h-full object-cover"
                      />

                      <div className="absolute top-3 left-3 bg-black bg-opacity-50 text-white px-3 py-1 rounded-md">
                        Status: {streamStatus}
                      </div>
                      {/* Show Like Button only when live */}
                      {isLive && (
                        <div className="absolute inset-x-0 bottom-4 px-4 flex justify-between items-end pointer-events-none">
                          <div className="bg-black/30 backdrop-blur-sm text-white px-4 py-1.5 rounded-full text-sm font-medium">
                            {viewerCount > 1000
                              ? (viewerCount / 1000).toFixed(1) + "K"
                              : viewerCount}{" "}
                            Viewers
                          </div>

                          {isLive && (
                            <div className="bg-[#BE1F2E] text-white px-4 py-1.5 rounded-full text-sm font-bold animate-pulse">
                              LIVE
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : cameraError ? (
                    <>
                      <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                        <div className="flex p-2 pl-5 items-center">
                          {/* Profile Image Inside Textarea */}
                          <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                            <img
                              src={profilePictureUrl}
                              alt="Profile"
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <div className="feed-title pl-4">
                            <p className="font-semibold text-[#000]">
                              {user?.first_name} {user?.last_name}
                            </p>

                            <p className="flex text-sm text-[#000]">
                              {startTime && formatDate(startTime)}
                            </p>
                          </div>
                        </div>
                      </div>
                      <img src={golivecam} alt="Go Live Camera" />
                      <p className="text-lg font-semibold">
                        Allow Access To Camera
                      </p>
                      <p className="text-sm text-gray-400 px-8 text-center">
                        Your Browser Is Not Allowing Live Producer Access To
                        Your Camera. Go To Your Browser Settings And Allow
                        Camera Permission.
                      </p>
                      <button
                        className="mt-4 px-6 py-2 bg-[#D9D9D9] text-[#000000] font-semibold rounded-xl"
                        onClick={startCamera} // ✅ Calls updated function
                      >
                        Retry
                      </button>
                    </>
                  ) : (
                    <>
                      <div
                        className="relative bg-cover bg-center h-[500px] w-full camera text-center"
                        style={{ backgroundImage: `url(${golivebanner})` }} // ✅ Dynamic Banner Image
                      >
                        <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                          <div className="flex p-2 pl-5 items-center">
                            {/* Profile Image Inside Textarea */}
                            <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                              <img
                                src={profilePictureUrl}
                                alt="Profile"
                                className="w-full h-full object-cover"
                              />
                            </div>
                            <div className="feed-title pl-4">
                              <p className="font-semibold text-[#000]">
                                {user?.first_name} {user?.last_name}
                              </p>
                              <p className="flex text-sm text-[#000]">
                                {startTime && formatDate(startTime)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {/* Controls - Hide in Viewer Mode */}

                <div className="golive-controls flex items-center justify-between p-4 rounded-lg bg-[#EBF8ED]">
                  {viewerMode ? (
                    <>
                      {/* Left Side: Mute & Report */}
                      <div className="flex items-center gap-4">
                        {/* Mute Button */}

                        {/* Report Button */}
                        <button
                          onClick={() => setIsReportModalOpen(true)}
                          className="flex items-center gap-2 px-6 py-2 rounded-full border border-red-500 text-red-500 bg-[#FDF2F2] hover:bg-red-50 transition-colors font-medium text-sm"
                        >
                          <FaExclamationCircle className="w-4 h-4" />
                          Report
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="flex space-x-4">
                      <div className="flex space-x-4">
                        {/* Mic Button First */}
                        <button
                          className={`p-3 rounded-full shadow-md ${
                            isMicOn ? "bg-[#FFFFFF80]" : "bg-red-500"
                          }`}
                          onClick={toggleMic}
                        >
                          <img
                            src={isMicOn ? microphone : cameraoff} // ✅ Use proper mic icon
                            className="w-5"
                            alt="Mic"
                          />
                        </button>
                      </div>
                      {/* Camera Button Second */}
                      <button
                        className={`p-3 rounded-full shadow-md ${
                          isCamOn ? "bg-[#FFFFFF80]" : "bg-red-500"
                        }`}
                        onClick={toggleCam}
                      >
                        <img
                          src={isCamOn ? videos : videoslash} // Can swap for camera-on icon if available
                          className="w-5"
                          alt="Cam"
                        />
                      </button>

                      {/* Toggle Switch */}
                      <label className="inline-flex items-center cursor-pointer relative toggle-golive">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={commentsEnabled}
                          onChange={toggleComments}
                        />
                        <div
                          className={`relative w-16 h-8 bg-[#095228] rounded-full peer-checked:bg-[#161F28] ${
                            commentsEnabled ? "bg-[#095228]" : "bg-[#161F28]"
                          }`}
                        >
                          {/* Knob */}
                          <div
                            className={`absolute top-[3px] left-[5px] w-6 h-6 bg-white border border-[#161F28] rounded-full transition-all ${
                              commentsEnabled ? "translate-x-full" : ""
                            }`}
                          />
                          {/* Single Span for ON/OFF */}
                          <span
                            className={`absolute text-xs text-white top-4 transform -translate-y-1/2 
                                                ${
                                                  commentsEnabled
                                                    ? "left-2"
                                                    : "left-8"
                                                }`}
                          >
                            {commentsEnabled ? "ON" : "OFF"}
                          </span>
                        </div>
                        <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300 ">
                          Comments
                        </span>
                      </label>
                    </div>
                  )}
                  {viewerMode ? (
                    <div className="flex flex-col items-end">
                      <button
                        className="bg-[#095228] text-[#fff] px-6 py-3 flex items-center gap-2 text-white rounded-full hover:bg-green-900 transition-colors rounded-full"
                        onClick={donategift}
                      >
                        <img src={whiteheart} alt="heart" className="w-5 h-5" />
                        Donate / Gift
                      </button>
                      <p className="text-[10px] text-gray-500 mt-1 font-medium">
                        *Viewers can send real-time donations during this live
                        stream.
                      </p>
                    </div>
                  ) : (
                    <div className="flex items-center space-x-4">
                      <div className="relative hidden md:block">
                        <button
                          onClick={toggleDropdown}
                          className="share-public flex items-center px-4 py-2"
                        >
                          <img src={global} alt="Globe" className="pr-2" />
                          {privacy}
                          <FaChevronDown className="ml-2 text-xs text-gray-400" />
                        </button>

                        {/* ✅ Show dropdown only if isOpen is true */}
                        {isOpen && (
                          <div className="absolute top-12 left-0 bg-white shadow-md rounded-md w-40 p-2 z-50">
                            <button
                              className="block w-full text-left px-3 py-2 hover:bg-gray-100"
                              onClick={() => changeVisibility("Public")}
                            >
                              Public
                            </button>
                            <button
                              className="block w-full text-left px-3 py-2 hover:bg-gray-100"
                              onClick={() => changeVisibility("Private")}
                            >
                              Private
                            </button>
                          </div>
                        )}
                      </div>
                      {/* Go Live / Resume Button */}
                      <div className="flex items-center justify-center">
                        {activeSessionAvailable && !isLive ? (
                          <button
                            className="bg-green-600 text-white px-8 py-2 rounded-full font-semibold hover:bg-green-700"
                            onClick={handleResumeLive}
                          >
                            Resume Live Stream
                          </button>
                        ) : (
                          <button
                            className={`px-8 py-2 rounded-full font-semibold
                                                  ${
                                                    isLive
                                                      ? "bg-[#BE1F2E] text-white font-semibold"
                                                      : "bg-blue-500 text-white px-8 py-2 rounded-full go-to-live-CTA"
                                                  }`}
                            onClick={handleGoLive}
                            // disabled={!title.trim() || !category.trim()} // ✅ Disable if fields missing
                          >
                            {isLive
                              ? "Stop"
                              : countdown > 0
                                ? `Going Live in ${countdown}s...`
                                : "Go Live"}
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Donation History - Visible if Stream ID exists (so creator sees it even if not 'live' yet) */}
                {streamId && !viewerMode && (
                  <div className="mt-4">
                    <DonationHistory
                      donations={donations}
                      totalAmount={totalDonationAmount}
                    />
                  </div>
                )}
              </div>
              {/* Show Fund & Banking Info ONLY when NOT Live (Preview Mode) */}
              {
                <div className="w-full max-w-6xl mx-auto space-y-12 my-5">
                  {/* ================= Fund Information ================= */}
                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <h2 className="text-[#095228] font-semibold text-lg">
                        Fund Information
                      </h2>
                      {!viewerMode && !isLive && (
                        <img
                          src={editgolive}
                          alt="Edit"
                          className="cursor-pointer"
                          onClick={() => setIsEditModalOpen(true)}
                        />
                      )}
                    </div>

                    <div className="border-b-2 border-[#D9D9D9] mb-6" />

                    {/* Title */}
                    <div className="mb-5">
                      <p className="text-[14px] text-gray-500 mb-1 font-medium">
                        Title
                      </p>
                      <p className="text-2xl font-medium">
                        {title || "No Title Provided"}
                      </p>
                    </div>

                    {/* Meta Info: Category & Goal Amount - First */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                      <div>
                        <p className="text-[14px] text-gray-500 mb-1 font-medium">
                          Category
                        </p>
                        <p className="font-normal">{categoryName}</p>
                      </div>

                      <div>
                        <p className="text-[14px] text-gray-500 mb-1 font-medium">
                          Goal Amount
                        </p>
                        <p className="font-semibold text-[#74131C] text-[22px]">
                          {currency || "$"} {goalAmount}
                        </p>
                      </div>
                    </div>

                    {/* Description - Second */}
                    <div className="mb-8 max-w-4xl">
                      <p className="text-[14px] text-gray-500 mb-1 font-medium">
                        Description
                      </p>
                      <p className="text-[#000000] text-[12px] leading-relaxed">
                        {description || "No description provided."}
                      </p>
                    </div>
                  </div>

                  {/* ================= Banking Information ================= */}
                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <h2 className="text-[#095228] font-semibold text-lg">
                        Banking Information
                      </h2>
                      {!viewerMode && !isLive && (
                        <img
                          src={editgolive}
                          alt="Edit"
                          className="cursor-pointer"
                          onClick={() => setIsEditModalOpen(true)}
                        />
                      )}
                    </div>

                    {/* Banking Information - Hidden for Viewers */}
                    {!viewerMode && (
                      <>
                        <div className="border-b-2 border-[#D9D9D9] mb-6" />

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                          <div>
                            <p className="text-[14px] text-gray-500 mb-1 font-medium">
                              Default Currency
                            </p>
                            <p className="font-normal">{currency}</p>
                          </div>
                          <div>
                            <p className="text-[14px] text-gray-500 mb-1 font-medium">
                              Beneficiary Name
                            </p>
                            <p className="font-normal">{beneficiaryName}</p>
                          </div>
                          <div>
                            <p className="text-[14px] text-gray-500 mb-1 font-medium">
                              Bank Name
                            </p>
                            <p className="font-normal">{bankName}</p>
                          </div>

                          <div>
                            <p className="text-[14px] text-gray-500 mb-1 font-medium">
                              Account Number
                            </p>
                            <p className="font-normal">{accountNumber}</p>
                          </div>

                          <div>
                            <p className="text-[14px] text-gray-500 mb-1 font-medium">
                              IFSC or SWIFT Code
                            </p>
                            <p className="font-normal">{ifsc}</p>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div>
                    {isLive && viewerMode && (
                      <button
                        className="bg-[#095228] text-[#fff] px-6 py-3 flex items-center gap-2 text-white rounded-full hover:bg-green-900 transition-colors rounded-full"
                        onClick={donategift}
                      >
                        <img src={whiteheart} alt="heart" className="w-5 h-5" />
                        Donate / Gift
                      </button>
                    )}

                    {/* The Modal Component */}
                    <GoLiveDonationgiftModal
                      isOpen={isModalOpen}
                      onClose={closeModal}
                      logo={logo}
                      closeIcon={closeIcon}
                      profileimg={profileimg}
                      profiledata={profiledata}
                    />
                  </div>
                  {/* Report Stream Modal */}
                  <ReportStreamModal
                    isOpen={isReportModalOpen}
                    onClose={() => setIsReportModalOpen(false)}
                    onSubmit={handleReportSubmit}
                    logo={logo}
                    closeIcon={closeIcon}
                  />
                </div>
              }

              {/* Edit Modal */}
              {isEditModalOpen && (
                <GoLiveDonationModal
                  isOpen={isEditModalOpen}
                  onClose={() => setIsEditModalOpen(false)}
                  logo={logo}
                  closeIcon={closeIcon}
                  categories={categories}
                  initialData={{
                    title,
                    category,
                    description,
                    goalAmount,
                    currency,
                    bankName,
                    ifsc,
                    beneficiaryName,
                    accountNumber,
                  }}
                  onSave={handleEditSave}
                />
              )}
            </div>
          </div>

          {/* Right Sidebar */}
          {/* Chat Section */}

          <div className="golive-chatbox bg-[#F9FAFB] p-4 mb-5 h-[650px] relative flex flex-col">
            {/* ✅ Live Stream Engagement Stats Header (Creator Only) */}
            {/* {!viewerMode && engagementStats && (
              <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100 mb-2 flex justify-around items-center z-20 shrink-0">
                <div className="flex flex-col items-center">
                  <span className="text-xs text-gray-500 font-medium uppercase tracking-wide">
                    Likes
                  </span>
                  <span className="text-lg font-bold text-red-500">
                    ❤️ {engagementStats.totalReactions || 0}
                  </span>
                </div>
                <div className="w-[1px] h-8 bg-gray-200"></div>
                <div className="flex flex-col items-center">
                  <span className="text-xs text-gray-500 font-medium uppercase tracking-wide">
                    Gifts
                  </span>
                  <span className="text-lg font-bold text-yellow-600">
                    🎁 {engagementStats.totalGifts || 0}
                  </span>
                </div>
                <div className="w-[1px] h-8 bg-gray-200"></div>
                <div className="flex flex-col items-center">
                  <span className="text-xs text-gray-500 font-medium uppercase tracking-wide">
                    Coins
                  </span>
                  <span className="text-lg font-bold text-yellow-600">
                    🪙 {engagementStats.totalCoins || 0}
                  </span>
                </div>
              </div>
            )} */}

            <div className="absolute top-0 right-0 w-full h-[50%] z-10 bg-gradient-to-t from-[#ffffff00] to-[#ffffff] pointer-events-none" />

            <div
              ref={chatContainerRef}
              className="h-full overflow-y-auto space-y-4 relative scrollbar-hidden"
            >
              {isLive || viewerMode ? (
                <div className="comments-section p-4">
                  {/* ✅ Merge Comments, Donations, and Reactions */}
                  {[...comments, ...donations, ...reactions]
                    .sort(
                      (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
                    )
                    .map((item) => {
                      const isDonation = item.type === "donation";
                      const isLike = item.type === "like";
                      const key = isLike
                        ? `like-${item.id}`
                        : isDonation
                          ? `donation-${item.id}`
                          : `comment-${item.commentId}`;

                      return (
                        <div
                          key={key}
                          className={`p-3 rounded-md relative group ${
                            isDonation
                              ? "bg-yellow-50 border border-yellow-200"
                              : isLike
                                ? "bg-pink-50 border border-pink-100"
                                : ""
                          }`}
                        >
                          <div className="flex">
                            <img
                              src={
                                isDonation || isLike ? item.avatar : profileimg // Use avatar if available
                              }
                              className="w-9 h-9 rounded-full object-cover"
                              alt="profile"
                            />
                            <div className="pl-2">
                              <p className="font-semibold flex items-center gap-2">
                                {item.username || item.name || "Anonymous"}
                                {isDonation && (
                                  <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full border border-yellow-300">
                                    Supporter
                                  </span>
                                )}
                                {isLike && (
                                  <span className="text-xs text-pink-500">
                                    <FaHeart className="inline w-3 h-3 mr-1" />
                                  </span>
                                )}
                              </p>
                              <p className="text-[10px] text-gray-500">
                                {new Date(
                                  item.timestamp || item.created_at,
                                ).toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </p>
                            </div>
                          </div>
                          <p
                            className={`text-[12px] break-words pt-2 ${
                              isDonation
                                ? "font-medium text-yellow-900"
                                : isLike
                                  ? "text-pink-600 italic"
                                  : ""
                            }`}
                          >
                            {isDonation
                              ? item.message || `Sent a gift!`
                              : isLike
                                ? "liked the stream"
                                : item.comment}
                          </p>
                          <hr className="mt-2 pt-[1px] bg-[#D9D9D9]" />

                          {/* Show delete only for own comments (not donations/likes for now) */}
                          {!isDonation &&
                            !isLike &&
                            item.userId === users.id && (
                              <button
                                onClick={() => deleteComment(item.commentId)}
                                className="absolute top-2 right-2 text-red-500 hover:text-red-700"
                              >
                                Delete
                              </button>
                            )}
                        </div>
                      );
                    })}
                  {[...comments, ...donations].length === 0 && (
                    <div className="flex h-full items-center justify-center text-gray-500">
                      No events yet.
                    </div>
                  )}
                </div>
              ) : (
                <div className="flex h-full items-center justify-center text-gray-500">
                  No Comments Available
                </div>
              )}
            </div>

            {/* Add Comment Input */}
            {commentsEnabled ? (
              <div className="flex items-center mt-4 w-full absolute bottom-2 right-0">
                <div className="relative flex w-full mx-2">
                  <input
                    type="text"
                    placeholder="Add a comment"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        postComment();
                      }
                    }}
                    className="flex-1 p-3 border border-gray-300 rounded-full focus:outline-none"
                  />
                  <button
                    onClick={postComment}
                    className="bg-blue-500 text-white px-4 py-2 rounded-full go-to-live-CTA absolute right-1 top-1"
                  >
                    Send
                  </button>
                </div>
                {/* Show Like Button only when live */}
                {(isLive || viewerMode) && (
                  <button
                    className={`bg-[#BE1F2E] text-white px-3 mx-2 py-3 rounded-full hover:bg-red-700 transition-all duration-200 transform ${
                      isLikeAnimating
                        ? "scale-125 bg-red-800 shadow-lg"
                        : "scale-100"
                    }`}
                    onClick={handleLike}
                  >
                    <img src={like} alt="Like" className="w-5 h-5" />
                  </button>
                )}
              </div>
            ) : (
              <div className="flex items-center justify-center h-[50px] w-full absolute bottom-2 right-0 text-gray-500 italic">
                Comments are turned off outside
              </div>
            )}
            {/* Footer */}
            <div className="lg:hidden">
              <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                © 2025 Pipaan. All Rights Reserved
              </div>
            </div>
          </div>
        </main>
      </main>
      {/* ✅ Donation Modal */}
      <GoLiveDonationgiftModal
        isOpen={isDonateModalOpen}
        onClose={() => setIsDonateModalOpen(false)}
        logo={logo}
        closeIcon={closeIcon}
        streamId={streamIdToUse || streamId}
        streamDetails={viewerStreamData || { title, user: users }}
      />

      {/* Report Stream Modal */}
      <ReportStreamModal
        isOpen={isReportModalOpen}
        onClose={() => setIsReportModalOpen(false)}
        logo={logo}
        closeIcon={closeIcon}
        onSubmit={handleReportSubmit}
      />
    </div>
    // stream_1768377437020_9ddc09bdf1e73848
    // stream_1768377437020_9ddc09bdf1e73848
  );
}
